import React, { useState } from 'react';

const ShortenAgainForm = ({ onProcess }) => {

  const [url, setUrl] = useState('');
  const [isError, setIsError] = useState(false);
 
  const handleInputChange = (event) => {
    setUrl(event.target.value);
    setIsError(false);
  };

  const handleButtonClick = () => {
    //urlを検証
    const urlPattern = /^https:\/\/ffxiv\.link\/[0-9]+$/;    
    if (!url || !urlPattern.test(url)) {
      setIsError(true);
      return;
    }
    //url問題無ければ処理
    setIsError(false);
    onProcess(url);    
  };
  

  return (
    <div id="short_url_input">
      <h2>短縮したURLを更に短縮</h2>
      <p className="read">当サイトで発行した数値のみの短縮URLを、英数字を組み合わせた更に短い形のURLに変換できます。<br />短縮したい「<strong>https://ffxiv.link/00000</strong>」の形のURLを入力してください。</p>
      {isError && (<p className="error">URLの形式が不正です。</p>)}
      <input type="text" name="short_url" id="short_url" value={url} onChange={handleInputChange} placeholder="例：https://ffxiv.link/000000" className="text" />
      <button className="submit" id="short_url_set" onClick={handleButtonClick}>数字のURLを更に短縮</button>
    </div>  
  );
};

export default ShortenAgainForm;